import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, waLink } from "../site";

export default function FloatingCta() {
    return (
        <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3 md:hidden">
            <a
                href={PHONE_TEL}
                data-testid="floating-call-button"
                aria-label="Call Trainer Aryan"
                className="glass flex h-12 w-12 items-center justify-center rounded-full"
            >
                <Phone size={19} className="text-[#F5C542]" />
            </a>
            <a
                href={waLink("Namaste Trainer Aryan, I would like to start training.")}
                target="_blank"
                rel="noreferrer"
                data-testid="floating-whatsapp-button"
                aria-label="Message Trainer Aryan on WhatsApp"
                className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_10px_30px_-6px_rgba(37,211,102,0.5)]"
            >
                <MessageCircle size={22} className="text-[#050505]" />
            </a>
        </div>
    );
}
